import * as t from "io-ts";
export const loginResultT = t.intersection([
    t.strict({ success: t.literal(true) }),
    t.exact(t.partial({ loginCodeRequired: t.literal(true) })),
]);
export const loginCodeStatusT = t.strict({ pending: t.boolean });
export const loginCodeInputT = t.strict({ code: t.string });
export const loginCodeVerifyResultT = t.union([
    t.strict({ ok: t.literal(true) }),
    t.strict({
        ok: t.literal(false),
        error: t.literal("INVALID_CODE"),
        attemptsLeft: t.number,
    }),
    t.strict({
        ok: t.literal(false),
        error: t.union([
            t.literal("TOO_MANY_ATTEMPTS"),
            t.literal("EXPIRED"),
            t.literal("NO_CODE"),
        ]),
    }),
]);
export const loginCodeResendResultT = t.union([
    t.strict({ ok: t.literal(true) }),
    t.strict({
        ok: t.literal(false),
        error: t.literal("TOO_SOON"),
        waitSeconds: t.number,
    }),
]);
//# sourceMappingURL=login-code.js.map